import { NgClass, NgTemplateOutlet } from "@angular/common";
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { IOption } from "~app/common/models/options-models";
import { ActionButtonComponent } from "../action-button/action-button.component";
import { BaseComponent } from "../base-component/base.component";
import { IconButtonComponent } from "../icon-button/icon-button.component";

@Component({
    selector: "rask-menu-button",
    templateUrl: "./menu-button.component.html",
    styleUrls: ["./menu-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        IconButtonComponent,
        NgClass,
        ActionButtonComponent,
        NgTemplateOutlet
    ]
})
export class MenuButtonComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() alignment: "left" | "right" = "right";
    @Input() icon: string;
    isOptions: boolean;
    isTemplate: boolean;
    @Input() label: string;
    @Input() options: IOption[];
    @Output() selected = new EventEmitter<IOption>();
    showMenu = false;
    @Input() template: TemplateRef<any>;

    private readonly cdRef = inject(ChangeDetectorRef);
    private readonly elementRef = inject(ElementRef);
    private readonly zone = inject(NgZone);

    get alignmentClass(): string {
        return this.alignment === "left" ? "align-left" : "align-right";
    }

    clickOut = (event) => {
        if (!this.showMenu || this.elementRef.nativeElement.contains(event.target)) {
            return;
        }

        this.showMenu = false;
        this.cdRef.detectChanges();
    };

    ngOnDestroy(): void {
        document.removeEventListener("click", this.clickOut);
    }

    ngOnInit() {
        this.isOptions = this.options?.length > 0;
        this.isTemplate = !this.isOptions;
        if (!this.icon) {
            // default ikon
            this.icon = this.isOptions ? "fa-solid fa-chevron-down" : "fa fa-bars";
        }

        this.zone.runOutsideAngular(() => {
            document.addEventListener("click", this.clickOut);
        });
    }

    optionClicked(option: IOption): void {
        this.selected.emit(option);
        this.showMenu = false;
    }

    toggle(): void {
        this.showMenu = !this.showMenu;
    }
}
